import React from "react";
import AddNewSalePlatformIntegrationDialog from "src/components/AddNewSalePlatformIntegrationDialog";
import { getAmazonOAuthUrl } from "src/apiService/modules/amazon";

export interface AddAmazonIntegrationDialogProps {
  open: boolean;
  onClose: () => void;
}
function AddAmazonIntegrationDialog({
  open,
  onClose,
}: AddAmazonIntegrationDialogProps) {
  return (
    <AddNewSalePlatformIntegrationDialog
      open={open}
      onClose={onClose}
      platformName="Amazon"
      onConnect={async (bankAccountId) => {
        const authResponse = await getAmazonOAuthUrl({ bankAccountId });
        window.location.href = authResponse.data.url;
      }}
    />
  );
}

export default AddAmazonIntegrationDialog;
